import * as $ from "jquery";
import * as ko from "knockout";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { PopupType } from "../popups/popupType";
import { Application } from "../application";


export class OpenEstimateImportPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenEstimateImportPopup;

    canExecute = ko.computed(() => {
        return true;
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.estimateImport, true).done(() => {
            
        });
    }

    name = "Import estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openEstimateImportPopupCommand.ts